import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, OnInit, OnDestroy, ChangeDetectorRef, inject } from '@angular/core';
import {
  ClrCheckboxModule,
  ClrComboboxModule,
  ClrDatagridModule,
  ClrDropdownModule,
  ClrFormsModule,
  ClrIcon,
  ClrInputModule,
  ClrSelectModule,
  ClarityModule,
} from '@clr/angular';
import { DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { AngularSplitModule } from 'angular-split';
import { environment } from 'src/environments/environment';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import JSZip from 'jszip';

import OlMap from 'ol/Map';
import OlView from 'ol/View';
import OlVectorLayer from 'ol/layer/Vector';
import OlVectorSource from 'ol/source/Vector';
import OlGeoJSON from 'ol/format/GeoJSON';
import OlStyle from 'ol/style/Style';
import OlStroke from 'ol/style/Stroke';
import { defaults } from 'ol/control';
import { fromLonLat } from 'ol/proj';
import { getLength as geoDesLength } from 'ol/sphere';
import { Feature } from 'ol';
import { Point } from 'ol/geom';
import CircleStyle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import { APIService } from 'src/app/services/APIService/api.service';
import * as Plotly from 'plotly.js-basic-dist-min';
import { BehaviorSubject, first } from 'rxjs';
import { SpinnerService } from 'src/app/services/Spinner/spinner.service';
import { ToastService } from 'src/app/services/toast.service';
import { Options } from '@angular-slider/ngx-slider';
import { ImageSlideShowComponent } from '../../_shared/media-slide-show/image-slide-show.component';
import { PlotlyPlotComponent } from '../../plotly-plot/plotly-plot.component';
import { FileForPreview } from '../../_shared/preview-thumbnails/preview-thumbnail.type';
import { dbS } from 'src/app/services/_offline/StorageDexie';
import { TileLayerObj } from 'src/app/content/GISMap/ol-exports';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-messungsuebersichtdialog',
  templateUrl: './messungsuebersichtdialog.component.html',
  styleUrls: ['./messungsuebersichtdialog.component.scss'],
  imports: [
    ClrDatagridModule,
    FormsModule,
    ClrIcon,
    ReactiveFormsModule,
    ClrDatagridModule,
    ClrDropdownModule,
    ClrFormsModule,
    ClrSelectModule,
    ClrInputModule,
    PlotlyPlotComponent,
    ClrComboboxModule,
    NgxSliderModule,
    ImageSlideShowComponent,
    ClrCheckboxModule,
    ClarityModule,
    MrTranslatePipe,
    AngularSplitModule,
  ],
})
export class MessungsuebersichtdialogComponent implements OnInit, OnDestroy {
  private readonly apiservice = inject(APIService);
  private readonly spinner = inject(SpinnerService);
  private readonly toastr = inject(ToastService);
  private readonly datePipe = inject(DatePipe);
  private readonly mrTranslate = inject(MrTranslatePipe);
  private readonly changeDet = inject(ChangeDetectorRef);

  selectionType: 'none' | 'single' | 'multi' = 'none';
  sortableColumns: string[] = [];
  filterableColumns: string[] = [];
  editableColumns: string[] = [];
  showFooter = true;
  paginationEnabled = true;
  manageColumnsEnabled = true;
  compactEnabled = true;
  showAvailableActions = true;
  showActionBar = true;
  showSingleClearSelection = true;
  showData = true;
  placeholderText: string = undefined;
  dbTest: boolean = false;
  splitTest: boolean = false;
  opened: boolean = false;
  LPDatum: string = '';

  optGroup: UntypedFormGroup = new UntypedFormGroup({
    show_Trassierung: new UntypedFormControl(true),
    show_GISMAP: new UntypedFormControl(true),
    show_Detailview: new UntypedFormControl(true),
    show_CamView: new UntypedFormControl(true),
    show_Gleismessung: new UntypedFormControl(true),
    show_ProfileViewer: new UntypedFormControl(true),
  });

  ngOnInit(): void {
    this.apiservice
      .getObjekttypen()
      .pipe()
      .subscribe((val: any) => {
        this.tblObjektTypen = val;
        this.getSettings();

        Plotly.newPlot('plotly_Left', this.graphL.data, this.graphL.layout, this.graphL.config as any);
        Plotly.newPlot('plotly_Right', this.graphL.data, this.graphL.layout, this.graphL.config as any);
        this.getPlotID('plotly_Left', 'l');
        this.getPlotID('plotly_Right', 'r');
      });
  }

  getSettings() {
    let val = JSON.parse(localStorage.getItem('MessungUebersichtSettings'));
    if (val) {
      this.optGroup.controls.show_Trassierung.setValue(val.show_Trassierung);
      this.optGroup.controls.show_GISMAP.setValue(val.show_GISMAP);
      this.optGroup.controls.show_Detailview.setValue(val.show_Detailview);
      this.optGroup.controls.show_CamView.setValue(val.show_CamView);
      this.optGroup.controls.show_Gleismessung.setValue(val.show_Gleismessung);
      this.optGroup.controls.show_ProfileViewer.setValue(val.show_ProfileViewer);

      this.changeDet.detectChanges();
    }
  }

  savePanelSettings() {
    let val = this.optGroup.value;
    localStorage.setItem('MessungUebersichtSettings', JSON.stringify(val));
    this.opened = false;
  }

  set data(dataIn: any) {
    this.ostammid = dataIn.id;
    this.pruefid = dataIn.pruefid;
    this.bild = dataIn.bild;
    this.LPDatum = this.datePipe.transform(dataIn.LPDatum, 'dd.MM.yyyy');
    this.getMessungen();
  }

  //#region Init View

  modalLinkGroup = new UntypedFormGroup({
    objTyp: new UntypedFormControl('', [Validators.required]),
    StammID: new UntypedFormControl('', [Validators.required]),
  });
  protected files$: FileForPreview[];
  ostammid: number;
  tblPruefids: any;
  selection: any;
  selpruefids: string = '';
  selDates: string[] = [];
  curIndex = 0;
  selIsOpen = false;
  map: OlMap;
  geolayer: any;
  Object = Object;
  placeHolderHeight = 50;
  draganddropactive = false;
  isDetailViewVisible = false;
  curGraph: any;
  layers: any[] = [];
  positionFeature = new Feature();
  highlightfeature: any;
  darkMap: boolean = false;

  min: number;
  max: number;

  defaultGraphData: any = [
    {
      name: 'Spur',
      key: 'Spur',
      yData: [],
    },
    {
      name: 'Bogen',
      key: 'Bogen',
      yData: [],
    },
    {
      name: 'Überhöhung',
      key: 'Ueberhoehung',
      yData: [],
    },
    {
      name: 'Tiefpunkt',
      key: 'Tiefpunkt',
      yData: [],
    },
    {
      name: 'Verwindung',
      key: 'Verwindung1',
      yData: [],
    },
    {
      name: 'Verwindung2',
      key: 'Verwindung2',
      yData: [],
    },
    {
      name: 'Rillen',
      key: 'Rille',
      yData: null,
    },
    {
      name: 'Rille links',
      key: 'Rille_L',
      yData: [],
    },
    {
      name: 'Rille rechts',
      key: 'Rille_R',
      yData: [],
    },
    {
      name: '∆H links',
      key: 'DH_L',
      yData: [],
    },
    {
      name: '∆S1 links',
      key: 'DS1_L',
      yData: [],
    },
    {
      name: '∆S2 links',
      key: 'DS2_L',
      yData: [],
    },
    {
      name: '∆H rechts',
      key: 'DH_R',
      yData: [],
    },
    {
      name: '∆S1 rechts',
      key: 'DS1_R',
      yData: [],
    },
    {
      name: '∆S2 rechts',
      key: 'DS2_R',
      yData: [],
    },
  ];

  graph: any = {
    layout: {
      autosize: true,
      hovermode: 'closest',
      showlegend: false,
      legend: { orientation: 'h' },
      height: 200,
      margin: {
        l: 35,
        r: 20,
        b: 25,
        t: 20,
        pad: 0,
      },
      plot_bgcolor: 'transparent',
      paper_bgcolor: 'transparent',
    },
    config: {
      responsive: true,
      displaylogo: false,
      locale: 'de',
      modeBarButtonsToRemove: [
        'sendDataToCloud',
        'lasso2d',
        'zoomOut2d',
        'zoomIn2d',
        'autoScale2d',
        'toggleSpikelines',
        'hoverCompareCartesian',
        'hoverClosestCartesian',
      ],
    },
    m: [],
    show: {},
    y: [],
    layouts: {
      Radius: {
        autosize: true,
        hovermode: 'closest',
        showlegend: false,
        legend: { orientation: 'h' },
        height: 200,
        margin: {
          l: 35,
          r: 20,
          b: 25,
          t: 20,
          pad: 0,
        },
        plot_bgcolor: 'transparent',
        paper_bgcolor: 'transparent',
        yaxis: {
          range: [-10000, 10000],
        },
      },
    },
    data: structuredClone(this.defaultGraphData),
  };

  tileLayers = TileLayerObj;

  minTol_Sp: number = -10000;
  maxTol_SP: number = 10000;
  curMessung: any = [];

  verletzung: any = [];
  showverletzung: boolean = false;
  showmesswerte: boolean = false;
  objektname: string = '';
  curObjTyp = 0;
  tblAnl: any;
  tblObjektTypen: any;

  objTypChanged(val: number) {
    this.curObjTyp = val;
    this.apiservice
      .getKarteAnlagen(this.curObjTyp)
      .pipe()
      .subscribe((res: any) => {
        if (res) {
          if (this.tblAnl?.columns?.length) this.tblAnl.rows = res.rows;
          else this.tblAnl = res;
        }
      });
  }

  getMessungen() {
    this.files$ = null;
    let stammid = this.ostammid;
    this.graph.data = structuredClone(this.defaultGraphData);

    this.apiservice
      .getMessungen(this.pruefid.toString(), stammid)
      .pipe(first())
      .subscribe((res: any) => {
        if (res.error) {
          this.toastr.warning(this.mrTranslate.transform('Keine Daten vorhanden'));
          this.close();
          return;
        }
        let settings = res.settings;
        let measurements = res.measurements;
        if (!measurements || (measurements.length == 1 && measurements[0].length == 0)) {
          this.spinner.disable();
          this.toastr.warning(this.mrTranslate.transform('Keine Daten vorhanden'));
          this.close();
          return;
        }

        this.minTol_Sp = Math.min(...measurements[0].map(item => item.SRG_M));
        this.maxTol_SP = Math.max(...measurements[0].map(item => item.SRG_P));
        this.curMessung = measurements[0];

        this.min = measurements[0][0]['m'];
        this.max = measurements[0][measurements[0].length - 1]['m'];
        for (this.curIndex = 0; this.curIndex < measurements.length; this.curIndex++) {
          const measurement = measurements[this.curIndex];

          measurement.forEach(val => {
            Object.keys(val).forEach((valName: any) => {
              let showName = valName;
              let ind = this.getGraphIndex(valName);
              if (val[valName] != null && val[valName] != 0) {
                if (valName == 'm') return;

                showName = valName;
                if (valName.includes('SR')) showName = 'Spur';
                if (valName == 'SollSpur') showName = 'Spur';

                if (valName == 'TolVer_M') showName = 'Verwindung';
                if (valName == 'TolVer_P') showName = 'Verwindung';

                ind = this.getGraphIndex(showName);
                if (ind != undefined) {
                  let correctName = valName.replace('_M', '-').replace('_P', '+');
                  let searchAddition = valName.includes('SR') ? '' : ' ' + this.selDates[this.curIndex];
                  let found = false;
                  for (const yData of this.graph.data[ind].yData) {
                    if (yData.name == correctName + searchAddition) {
                      found = true;
                      yData.x.push(val['m']);
                      yData.y.push(val[valName]);
                      break;
                    }
                  }
                  if (!found) {
                    let newPlot: any = {
                      name: correctName + searchAddition,
                      visible: valName.includes(valName) ? true : 'legendonly',
                      type: 'scatter',
                      marker: {
                        size: Number.MIN_VALUE,
                      },
                      mode: 'line',
                      x: [val['m']],
                      y: [val[valName]],
                    };
                    this.graph.data[ind].yData.push(newPlot);
                  }
                }
              }

              if (showName != 'm' && ind !== undefined) {
                if (!showName.toLowerCase().includes('ds') && !showName.toLowerCase().includes('dh')  && !showName.toLowerCase().includes('fahrdraht')) {
                  this.graph.data[ind].show = true;
                }
                if(showName.toLowerCase().includes('fahrdraht') && this.graph.data[ind].yData.length > 0) {
                  this.graph.data[ind].show = true;
                }
                if (
                  !this.graph.data[ind].layout &&
                  settings[showName].ymin !== undefined &&
                  settings[showName].ymax !== undefined
                ) {
                  let layout = structuredClone(this.graph.layout);
                  layout.showlegend = true;

                  layout.yaxis = {
                    range: [settings[showName].ymin, settings[showName].ymax],
                  };
                  this.graph.data[ind].layout = layout;
                }
              }
            });
          });
        }

        this.graph.data[7].show = false;
        this.graph.data[8].show = false;

        this.graph.data.forEach(element => {
          if (element.name == 'Verwindung') {
            element.yData.forEach(i => {
              if (i.name == 'Verwindung1 ') {
                i.name = 'Verwindung';
                i.line = { color: 'rgb(53, 132, 187)' };
              }
              if (i.name == 'TolVer- ') {
                i.name = 'SRG -';
                i.line = { color: 'rgb(247, 0, 0)' };
              }
              if (i.name == 'TolVer+ ') {
                i.name = 'SRG +';
                i.line = { color: 'rgb(247, 0, 0)' };
              }
            });
          }
        });

        let sp = structuredClone(this.graph.data[0].yData);

        sp.forEach(element => {
          if (element.name == 'SollSpur ') {
            element.name = 'Soll';
            element.line = { color: 'rgb(0, 0, 0)' };
          }
          if (element.name.includes('SRG')) {
            element.line = { color: 'rgb(247, 0, 0)' };
          }
          if (element.name.includes('SRlim')) {
            element.line = { color: 'rgb(247, 247, 0)', dash: 'dashdot' };
          }
          if (element.name.includes('SR100')) {
            element.line = { color: 'rgb(0, 247, 74)', dash: 'dot' };
          }
          if (element.name == 'Spur ') {
            element.name = 'Spur';
            element.line = { color: 'rgb(53, 132, 187)' };
          }
        });

        let sp_new = [];
        let soll = sp.filter(x => x.name.includes('Soll'));
        soll.forEach(element => {
          sp_new.push(element);
        });
        let sr1 = sp.filter(x => x.name.includes('SR100'));
        sr1.forEach(element => {
          sp_new.push(element);
        });
        let srl = sp.filter(x => x.name.includes('SRlim'));
        srl.forEach(element => {
          sp_new.push(element);
        });
        let srg = sp.filter(x => x.name.includes('SRG'));
        srg.forEach(element => {
          sp_new.push(element);
        });
        let spur = sp.filter(x => x.name.includes('Spur'));
        spur.forEach(element => {
          sp_new.push(element);
        });
        this.graph.data[0].yData = sp_new;

        this.apiservice
          .getPassBilder(this.bild)
          .pipe(first())
          .subscribe(x => (this.files$ = x));
        this.loadDetailView(this.graph.data[0], this.ostammid);
        this.loadData();
        this.loadTrass();
      });
  }

  getGraphIndex(key: string): number {
    for (let i = 0; i < this.graph.data.length; i++) {
      if (this.graph.data[i].key.includes(key)) {
        return i;
      }
    }
    return undefined;
  }

  loadDetailView(graphData: any, ostammid: number) {
    this.curGraph = structuredClone(graphData); //Deep Copy
    this.isDetailViewVisible = true;

    this.apiservice
      .getMessungGeo(ostammid)
      .pipe()
      .subscribe((res: any) => {
        setTimeout(() => {
          this.loadMap(res);
          this.loadGraph();
        });
      });
  }

  loadMap(res: any) {
    if (res && !this.geolayer) {
      this.layers = [];
      Object.keys(this.tileLayers).forEach(catname => {
        Object.keys(this.tileLayers[catname]).forEach(layername => {
          this.tileLayers[catname][layername].setVisible(false);
          this.layers.push(this.tileLayers[catname][layername]);
        });
      });
      let karte = JSON.parse(localStorage.getItem('karte'));
      this.tileLayers[karte.p][karte.m].setVisible(true);
      this.geolayer = new OlVectorLayer({
        source: new OlVectorSource({
          format: new OlGeoJSON(),
          loader: (extent, resolution, projection) => {
            dbS.getGIS(localStorage.getItem('DB') + localStorage.getItem('karteFileID')).then(x => {
              if (x?.features?.length > 0) {
                //Lade per GIS-IndexedDB
                let src = this.geolayer.getSource();
                setTimeout(() => {
                  let features = src.getFormat().readFeatures(x, {
                    featureProjection: 'EPSG:3857',
                  });
                  src.addFeatures(features);

                  let featurewrap: any = {
                    type: 'Feature',
                    geometry: res,
                  };
                  this.highlightfeature = this.geolayer.getSource().getFormat().readFeature(featurewrap, {
                    featureProjection: 'EPSG:3857',
                  });
                  this.geolayer.getSource().addFeature(this.highlightfeature);
                  this.geolayer.getSource().addFeature(this.positionFeature);
                  setTimeout(
                    () =>
                      this.map
                        .getView()
                        .fit(this.highlightfeature.getGeometry().getExtent(), { duration: 100, maxZoom: 19 }),
                    1000
                  );
                });
              }
            });
          },
        }),
        style: this.getLayerStyles(),
      });
      this.layers.push(this.geolayer);
    }
    if (!this.map) {
      this.map = new OlMap({
        target: 'previewMap',
        layers: this.layers,
        view: new OlView({
          center: fromLonLat([6.747443, 49.981018]),
          maxZoom: 23,
          zoom: 15,
        }),
        controls: defaults({ attribution: false, rotate: false, zoom: false }),
      });
    }

    if (res) {
      this.geolayer.getSource().on('change', () => {
        if (!this.positionFeature.getGeometry()) {
          this.map.getView().fit(this.geolayer.getSource().getExtent(), {
            duration: 100,
            maxZoom: 21,
          });
        } else {
          this.map.getView().fit(this.positionFeature.getGeometry().getExtent(), {
            duration: 100,
            maxZoom: 19,
          });
        }
      });
    }
  }

  loadGraph() {
    this.curGraph.layout.height = 250;
    Plotly.newPlot('plotly_Sub', this.curGraph.yData, this.curGraph.layout);
    let myPlot: any = document.getElementById('plotly_Sub');
    myPlot.on('plotly_click', data => {
      let dataPoint = {
        mode: 'line',
        name: 'Selektierte Position',
        type: 'lines',
        x: [data.points[0].x, data.points[0].x],
        y: [this.curGraph.layout.yaxis.range[0], this.curGraph.layout.yaxis.range[1]],
        visible: true,
      };
      if (this.curGraph.yData[this.curGraph.yData.length - 1].name == 'Selektierte Position') {
        this.curGraph.yData[this.curGraph.yData.length - 1] = dataPoint;
      } else {
        this.curGraph.yData.push(dataPoint);
      }

      Plotly.react('plotly_Sub', this.curGraph.yData, this.curGraph.layout);

      if (this.max > this.min) {
        this.getFeatPos((data.points[0].x - this.min).toString());
      } else {
        this.getFeatPos((data.points[0].x - this.max).toString());
      }
    });
  }
  getFeatPos(pos: string) {
    //Profileviewer
    try {
      let index = (this.profiles[0] as any[]).findIndex(
        x => Math.round(x.Position / 0.5) * 0.5 == Math.round(parseFloat(pos) / 0.5) * 0.5
      );

      this.ind = index;
    } catch (error) {}

    //GISMAP
    let coordPoint = this.highlightfeature
      .getGeometry()
      .getCoordinateAt(parseFloat(pos) / geoDesLength(this.highlightfeature.getGeometry()));
    this.geolayer.setStyle(this.getLayerStyles());

    this.positionFeature.setGeometry(new Point(coordPoint));
    this.positionFeature.setStyle(
      new OlStyle({
        image: new CircleStyle({
          radius: 6,
          fill: new Fill({
            color: 'green',
          }),
          stroke: new OlStroke({
            color: 'green',
            width: 2,
          }),
        }),
        zIndex: 3,
      })
    );
  }

  getLayerStyles() {
    return (feature, resolution) => {
      let prop = feature.getProperties();
      if (prop.geometry.getType() == 'LineString' || prop.geometry.getType() == 'MultiLineString') {
        if (
          JSON.stringify(feature.getGeometry().getCoordinates()) ===
          JSON.stringify(this.highlightfeature.getGeometry().getCoordinates())
        ) {
          return new OlStyle({
            stroke: new OlStroke({
              color: 'red',
              width: 4,
            }),
            zIndex: 2,
          });
        } else {
          return new OlStyle({
            stroke: new OlStroke({
              color: this.darkMap ? 'grey' : 'black',
              width: 4,
            }),
            zIndex: 1,
          });
        }
      }
    };
  }

  //#endregion

  //#region ProfileView
  private pruefid: number;
  private bild: string;
  isLoading: boolean = false;
  public profiles: any = [];
  private sollProfiles: any = {};
  public index: number = 0;
  @ViewChild('myCanvasL', { static: true }) canvasRefL: ElementRef;
  @ViewChild('myCanvasR', { static: true }) canvasRefR: ElementRef;

  public GLOB_SCALE: number = 1;
  public ds = { l1: 0, l2: 0, lh: 0, r1: 0, r2: 0, rh: 0 };
  public xy = { x: 0, y: 0, x2: 0, y2: 0 };
  public moveStepL: number = 1;
  public moveStepR: number = 1;
  public set ind(newindex: number) {
    if (newindex != -1) {
      this.index = newindex;
      this.changeIndex(newindex, 0);
    }
  }
  public get ind() {
    return this.index;
  }
  public indexScrub: BehaviorSubject<number> = new BehaviorSubject(0);
  public closedialog: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public slideroptions: Options = {
    floor: 0,
    ceil: 100,
  };

  public;

  graphL = {
    show: true,
    id: 'plotly_Left',
    layout: {
      autosize: false,
      showlegend: false,
      width: 400,
      height: 350,
      margin: {
        l: 20,
        r: 20,
        b: 20,
        t: 20,
        pad: 0,
      },
      plot_bgcolor: 'transparent',
      paper_bgcolor: 'transparent',
      yaxis: {
        //autorange: true,
        range: [-40, 100], //[Math.min(...measurements) - 10, Math.max(...measurements) + 10],
        //type: "linear",
      },
      xaxis: {
        //autorange: true,
        range: [-90, 50],
      },
    },
    config: {
      responsive: true,
      displaylogo: false,
      locale: 'de',
      modeBarButtonsToRemove: ['sendDataToCloud', 'lasso2d'],
    },
    data: [],
  };

  graphR = {
    id: 'plotly_Right',
    layout: {
      autosize: false,
      showlegend: false,
      width: 400,
      height: 350,
      margin: {
        l: 20,
        r: 20,
        b: 20,
        t: 20,
        pad: 0,
      },
      plot_bgcolor: 'transparent',
      paper_bgcolor: 'transparent',
      yaxis: {
        //autorange: true,
        range: [-40, 100], //[Math.min(...measurements) - 10, Math.max(...measurements) + 10],
        //type: "linear",
      },
      xaxis: {
        //autorange: true,
        range: [-50, 90],
      },
    },
    config: {
      responsive: true,
      displaylogo: false,
      locale: 'de',
      modeBarButtonsToRemove: ['sendDataToCloud', 'lasso2d'],
    },
    data: [],
  };

  private readonly subscribtions: any = {};

  loadData() {
    this.isLoading = true;
    this.profiles = [];
    this.apiservice
      .getAnlageProfil(this.ostammid, '-1')
      .pipe()
      .subscribe(res => {
        // 1.Daten immer zuerst
        let jsZip = typeof (<any>JSZip).default === 'function' ? new (<any>JSZip).default() : new JSZip();
        jsZip
          .loadAsync(res)
          .then(zip => {
            return zip.file('tmp.txt').async('string');
          })
          .then(zipf => {
            const list = JSON.parse(zipf);

            if (list.length > 0) {
              for (let x = 0; x < list.length; x++) {
                this.setData(list[x], x);
              }
              this.render(0);
            }
            this.isLoading = false;
          });
      });
  }

  setData(obj, lstID) {
    this.profiles[lstID] = [];
    let result = obj.sollProfile;
    for (let key in result) {
      let sl = result[key]['SollL'].split('|');
      let sr = result[key]['SollR'].split('|');
      let solll = { x: [], y: [] };
      let sollr = { x: [], y: [] };
      sl = sl.map(el => el.split(';'));
      sl.forEach(element => {
        solll.x.push(parseFloat(element[0]));
        solll.y.push(parseFloat(element[1]));
      });
      sr = sr.map(el => el.split(';'));
      sr.forEach(element => {
        sollr.x.push(parseFloat(element[0]));
        sollr.y.push(parseFloat(element[1]));
      });
      result[key]['SollL'] = solll;
      result[key]['SollR'] = sollr;
    }
    this.sollProfiles = result;

    for (let result of obj.profiles) {
      let sl = result['IstL']?.split('|');
      let sr = result['IstR']?.split('|');
      let istl = { x: [], y: [] };
      let istr = { x: [], y: [] };
      if (!sl || !sr) continue;
      sl = sl.map(el => el.split(';'));
      sl.forEach(element => {
        istl.x.push(parseFloat(element[0]));
        istl.y.push(parseFloat(element[1]));
      });
      sr = sr.map(el => el.split(';'));
      sr.forEach(element => {
        istr.x.push(parseFloat(element[0]));
        istr.y.push(parseFloat(element[1]));
      });
      result['IstL'] = istl;
      result['IstR'] = istr;
      this.profiles[lstID][result.zIndex] = result;
    }

    this.slideroptions = {
      floor: 0,
      translate: this.getPosition,
      ceil: Object.keys(this.profiles[0]).length - 1,
      animate: false,
    };
  }
  ngOnDestroy(): void {
    this.subscribtions?.profiles?.unsubscribe();
    this.profiles = null;
    this.sollProfiles = null;
  }

  close() {
    this.closedialog.next(true);
    this.indexScrub.next(-1);
  }

  getPlotID(event: any, side: any) {
    let plotID = event;
    let myPlot: any = document.getElementById(plotID);
    side == 'l' ? (this.graphL.id = plotID) : (this.graphR.id = plotID);
    myPlot.on('plotly_click', data => {
      let graph: any;
      side == 'l' ? (graph = this.graphL) : (graph = this.graphR);

      graph.data = graph.data.filter(item => item.name != 'Distanzmessung');
      if (data.points.length == 1) {
        let dataPoint;
        let txt;
        if (!this.xy.x || (this.xy.x && this.xy.x2)) {
          this.xy.x = data.points[0].x;
          this.xy.y = data.points[0].y;
          this.xy.x2 = undefined;
          this.xy.y2 = undefined;
          dataPoint = {
            x: [this.xy.x],
            y: [this.xy.y],
            name: 'Distanzmessung',
            type: 'lines+marker',
          };
          txt = 'x=0.00 mm y=0.00 mm dist=0.00 mm';
          //Plotly.addTraces(graph.id,{ x: [this.xy.x], y: [this.xy.y], name: "Distanzmessung"})
        } else {
          this.xy.x2 = data.points[0].x;
          this.xy.y2 = data.points[0].y;
          let dist = this.getDistanceNum(this.xy.x, this.xy.x2, this.xy.y, this.xy.y2);
          txt =
            'x=' +
            (this.xy.x - this.xy.x2).toFixed(2) +
            ' mm y=' +
            (this.xy.y - this.xy.y2).toFixed(2) +
            ' mm dist=' +
            dist +
            ' mm';
          dataPoint = {
            x: [this.xy.x, this.xy.x2],
            y: [this.xy.y, this.xy.y2],
            name: 'Distanzmessung',
            type: 'lines+marker',
          };
          //Plotly.addTraces(graph.id,{ x: [this.xy.x, this.xy.x2], y: [this.xy.y, this.xy.y2], name: "Distanzmessung"})
        }

        graph.layout.annotations = [
          {
            text: txt,
            x: NaN, //Garantiert dass Annotation immer oben links zu sehen ist.
            y: NaN,
            showarrow: false,
          },
        ];

        graph.data.push(dataPoint);
        Plotly.react(this.graphL.id, this.graphL.data, this.graphL.layout);
        Plotly.react(this.graphR.id, this.graphR.data, this.graphR.layout);
      }
    });
  }

  changeIndex(index, profileID) {
    if (this.profiles[profileID][index]) {
      this.ds.l1 = this.profiles[profileID][index].dS1L;
      this.ds.l2 = this.profiles[profileID][index].dS2L;
      this.ds.lh = this.profiles[profileID][index].dhL;
      this.ds.r1 = this.profiles[profileID][index].dS1R;
      this.ds.r2 = this.profiles[profileID][index].dS2R;
      this.ds.rh = this.profiles[profileID][index].dhR;

      this.indexScrub.next(parseFloat(this.profiles[profileID][index]['Position']));
      this.render(index);
    } else {
      this.graphL.data = [];
      this.graphR.data = [];
      let loadtrace = {
        x: [-20, -20],
        y: [40, 40],
        mode: 'markers+text',
        name: 'Loading',
        text: ['Daten werden geladen...'],
        textposition: 'bottom',

        type: 'scatter',
      };
      this.graphL.data = [loadtrace];
      this.graphR.data = [loadtrace];
      if (this.graphL.id) {
        Plotly.react(this.graphL.id, this.graphL.data, this.graphL.layout);
        Plotly.react(this.graphR.id, this.graphR.data, this.graphR.layout);
      }
    }
  }

  render(index: any) {
    let lstSollL = this.sollProfiles[this.profiles[0][this.ind]['ProfilL']]['SollL'];
    let lstSollR = this.sollProfiles[this.profiles[0][this.ind]['ProfilR']]['SollR'];
    let lstIstL = [];
    let lstIstR = [];
    //this.graphL.show = false;
    for (const prof of this.profiles) {
      lstIstL.push({
        x: prof[index].IstL.x,
        y: prof[index].IstL.y,
        name: 'L',
      });
      lstIstR.push({ x: prof[index].IstR.x, y: prof[index].IstR.y, name: 'R' });
    }
    this.graphL.data = [
      {
        x: lstSollL.x,
        y: lstSollL.y,
        name: this.profiles[0][this.ind]['ProfilL'],
      },
    ].concat(lstIstL);
    this.graphR.data = [
      {
        x: lstSollR.x,
        y: lstSollR.y,
        name: this.profiles[0][this.ind]['ProfilR'],
      },
    ].concat(lstIstR);
    if (this.graphL.id) {
      Plotly.react(this.graphL.id, this.graphL.data, this.graphL.layout);
      Plotly.react(this.graphR.id, this.graphR.data, this.graphR.layout);
    }
  }

  getPosition = val => {
    if (val !== undefined && !Number.isNaN(val)) {
      if (this.profiles[0][val]) {
        return +this.profiles[0][val]['Position'];
      }
      return val;
    }
    return '0';
  };

  public getDistance(p1: PointProf, p2: PointProf) {
    let a = p1.x - p2.x;
    let b = p1.y - p2.y;

    return Math.sqrt(a * a + b * b);
  }
  public getDistanceNum(p1x: number, p2x: number, p1y: number, p2y: number) {
    let a = p1x - p2x;
    let b = p1y - p2y;

    return Math.sqrt(a * a + b * b).toFixed(2);
  }

  private window = window;
  //#endregion

  //#region Trassierungsview

  selecteddata: any;
  public seltyp: number = 0;
  typen: any;
  selectedtyp: any;
  selectedmess: any;
  selid: number = 0;
  startmeter: number = 0;
  endmeter: number = 0;
  richtung: number = 0;

  graphTrass: any = [];
  layout: any = {
    autosize: true,
    hovermode: 'closest',
    showlegend: false,
    legend: { orientation: 'h' },
    height: 200,
    margin: {
      l: 20,
      r: 20,
      b: 20,
      t: 20,
      pad: 0,
    },
    plot_bgcolor: 'transparent',
    paper_bgcolor: 'transparent',
  };
  graphconfig: any = {
    responsive: true,
    displaylogo: false,
    locale: 'de',
    modeBarButtonsToRemove: [
      'sendDataToCloud',
      'lasso2d',
      'zoomOut2d',
      'zoomIn2d',
      'autoScale2d',
      'toggleSpikelines',
      'hoverCompareCartesian',
      'hoverClosestCartesian',
    ],
  };
  selecteditem: any;
  detailState: any;
  seltypid: any;

  loadTrass() {
    let trass = {
      status: 'gettyp',
      ostammid: this.ostammid,
      typ: 0,
    };

    this.apiservice
      .sendOSTEDT(trass)
      .pipe(first())
      .subscribe((res: any) => {
        this.typen = res.typen.rows;
        this.startmeter = res.startmeter;
        this.endmeter = res.endmeter;

        if (this.startmeter > this.endmeter) this.richtung = 1;
        this.selectedTrassChanged('0: 1');
      });
  }

  selectedMessChanged(value) {
    this.curGraph = this.graph.data[value.split(':')[0]];
    this.loadGraph();
  }
  selectedTrassChanged(value) {
    let v = value.toString().split(':');
    let v1 = parseInt(v[0]);
    if (v.length > 1) {
      v1 = parseInt(v[1].toString().replace(' ', ''));
    }

    this.seltypid = v1;

    if (this.selecteddata != undefined) {
      if (this.selecteddata.rows != undefined) {
        this.selecteddata.rows = [];
      }
    }

    this.graphTrass = [];
    let tmpstart = this.startmeter;
    let tmpende = this.endmeter;

    if (this.richtung == 1) {
      tmpstart = this.endmeter;
      tmpende = this.startmeter;
    }

    this.seltyp = v1;
    let trass = {
      status: 'get',
      ostammid: this.ostammid,
      typ: this.seltyp,
    };

    this.apiservice
      .sendOSTEDT(trass)
      .pipe(first())
      .subscribe((res: any) => {
        if (this.selecteddata == undefined) {
          this.selecteddata = res;
        } else {
          this.selecteddata.rows = res.rows;
        }

        switch (this.seltyp.toString()) {
          case '1':
          case '2':
          case '3':
          case '6':
            {
              this.name = this.mrTranslate.transform('Überhöhung');

              let x = [];
              let y = [];
              let lastX;
              let lastY;

              for (let i = 0; i < this.selecteddata.rows.length; i++) {
                let row = this.selecteddata.rows[i];
                let s = row['Startposition'];
                let e = row['Endposition'];
                let aw = row['Anfangswert'];
                let ew = row['Endwert'];

                if (i == 0) {
                  if (s > tmpstart) {
                    x.push(tmpstart);
                    y.push(0);
                  }
                  lastX = s;
                }

                if (lastX < s) {
                  x.push(lastX);
                  y.push(0);

                  x.push(s);
                  y.push(0);
                }

                if (this.richtung == 1) {
                  x.push(e);
                  y.push(aw);
                  x.push(s);
                  y.push(ew);
                } else {
                  x.push(s);
                  y.push(aw);
                  x.push(e);
                  y.push(ew);
                }

                if (i == this.selecteddata.rows.length - 1) {
                  if (e < tmpende) {
                    x.push(e);
                    y.push(0);
                    x.push(tmpende);
                    y.push(0);
                  }
                }

                lastX = e;
                lastY = ew;
              }

              for (let i = 1; i < x.length; i++) {
                let tx0 = x[i - 1];
                let tx1 = x[i];
                let ty0 = y[i - 1];
                let ty1 = y[i];

                if (tx0 == tx1 && ty0 == ty1) {
                  x.splice(i, 1);
                  y.splice(i, 1);
                }
              }

              if (value == '6') {
                let xm = [];
                let ym = [];
                let tx = [];

                for (const element of this.selecteddata.rows) {
                  let row = element;
                  let s = row['Startposition'];
                  let e = row['Endposition'];
                  let aw = row['Anfangswert'];
                  let ew = row['Endwert'];

                  if (this.richtung == 1) {
                    s = row['Endposition'];
                    e = row['Startposition'];
                  }

                  let _xm = (e + s) / 2;
                  let _ym = (aw + ew) / 2;

                  xm.push(_xm);
                  ym.push(_ym);
                  tx.push(row['Steigung'] + ' ‰');
                }

                let xt = [];
                let yt = [];
                let tt = [];

                for (let i = 1; i < this.selecteddata.rows.length; i++) {
                  let row0 = this.selecteddata.rows[i - 1];
                  let row1 = this.selecteddata.rows[i];

                  let aw = row1['Anfangswert'];
                  let s = row1['Startposition'];
                  let e = row1['Endposition'];
                  if (this.richtung == 1) {
                    s = row1['Endposition'];
                    e = row1['Startposition'];
                  }
                  let stg0 = row0['Steigung'];
                  let stg1 = row1['Steigung'];
                  let ar = row1['Radius'];

                  let stg = stg0 / 10 - stg1 / 10;
                  let t = Math.abs(((ar / 2) * stg) / 100);
                  let f = (t * t) / (2 * ar);
                  let h = Math.abs(row0['Endwert'] - row0['Anfangswert']);
                  let l = Math.abs(row0['Endposition'] - row0['Startposition']);

                  let alpha1 = Math.atan(h / l);
                  let _ba = Math.tan(alpha1) * t;

                  h = Math.abs(row1['Endwert'] - row1['Anfangswert']);
                  l = Math.abs(row1['Endposition'] - row1['Startposition']);

                  let alpha2 = Math.atan(h / l);
                  let _be = Math.tan(alpha2) * t;

                  let BaX = s - t;
                  let BeX = s + t;
                  let BaY = aw - _ba;
                  let BeY = aw - _be;
                  let stHW = 'HW';

                  if (stg0 > 0 && stg1 < 0) {
                    BaY = aw - _ba;
                    BeY = aw - _be;
                    stHW = 'HK';
                  }

                  if (stg0 <= 0 && stg1 > 0) {
                    BaY = aw + _ba;
                    BeY = aw + _be;
                    stHW = 'HW';
                  }

                  if (stg0 < 0 && stg1 < 0) {
                    BaY = aw + _ba;
                    BeY = aw - _be;
                    stHW = 'HW';

                    if (stg0 > stg1) stHW = 'HK';
                  }

                  if (stg0 < 0 && stg1 == 0) {
                    BaY = aw + _ba;
                    BeY = aw - _be;
                    stHW = 'HW';
                  }

                  if (stg0 > 0 && stg1 > 0) {
                    BaY = aw - _ba;
                    BeY = aw + _be;
                    stHW = 'HW';

                    if (stg0 > stg1) stHW = 'HK';
                  }

                  xt.push(BaX);
                  yt.push(BaY);

                  xt.push(BeX);
                  yt.push(BeY);

                  let strLbl = BeX.toFixed(3) + '<br>';
                  strLbl += BeY.toFixed(3) + '<br>';
                  strLbl += stHW + ' = ' + ar.toFixed(0) + '<br>';
                  strLbl += 'T = ' + t.toFixed(3) + '<br>';
                  strLbl += 'f = ' + f.toFixed(3) + '<br>';
                  tt.push(strLbl);
                }

                let newtt = [];
                if (this.selecteddata.rows.length > 1) {
                  let row0 = this.selecteddata.rows[0];
                  let aw = row0['Anfangswert'];

                  newtt.push(aw.toString() + '<br>');
                  for (const element of tt) {
                    newtt.push(element);
                  }
                  row0 = this.selecteddata.rows[this.selecteddata.rows.length - 1];
                  aw = row0['Endwert'];
                  newtt.push(aw.toString() + '<br>');
                }

                let trace1 = {
                  x: x,
                  y: y,
                  mode: 'lines+markers+text',
                  name: this.name,
                  line: {
                    color: 'rgb(128, 0, 128)',
                  },
                  text: newtt,
                  textposition: 'top',
                  marker: {
                    color: 'rgb(0, 0, 0)',
                    size: 14,
                  },
                };

                let traceT = {
                  x: xt,
                  y: yt,
                  mode: 'markers',
                  name: this.name + 'mittett',
                  marker: {
                    color: 'rgb(0, 0, 0)',
                    symbol: 'diamond',
                    size: 7,
                  },
                };

                let traceM = {
                  x: xm,
                  y: ym,
                  mode: 'text',
                  name: this.name + 'mitte',
                  text: tx,
                  textposition: 'top',
                  marker: {
                    color: 'rgb(128, 0, 128)',
                    size: 8,
                  },
                };

                if (x.length > 0) this.graphTrass = [trace1, traceM, traceT];
              } else {
                let trace = {
                  x: x,
                  y: y,
                  mode: 'lines+markers',
                  name: this.name,
                  line: {
                    color: 'rgb(60, 133, 0)',
                  },
                };

                if (x.length > 0) this.graphTrass = [trace];
              }
            }
            break;
        }
      });
  }

  name: string = '';
  //#endregion
}

export class PointProf {
  x: number = null;
  y: number = null;
}
